import { Alert, AlertDescription } from "@/components/ui/alert";

interface ReferralInfoProps {
  referralCode?: string | null;
  isAuthenticated: boolean;
  isOwnReferralCode: boolean;
  isValidReferralCode: boolean;
}

const ReferralInfo = ({
  referralCode,
  isAuthenticated,
  isOwnReferralCode,
  isValidReferralCode,
}: ReferralInfoProps) => {
  if (!referralCode) return null;
  
  if (!isAuthenticated) {
    return (
      <Alert className="mb-4">
        <AlertDescription>
          {isValidReferralCode 
            ? "Sign up to claim your £5 credit and book this event! Your referral discount will be automatically applied."
            : "Sign up to book this event!"
          }
        </AlertDescription>
      </Alert>
    );
  }

  // Only show validation errors for authenticated users
  if (isOwnReferralCode) {
    return (
      <div className="mb-4 p-2 bg-red-50 text-red-700 rounded-md text-sm">
        You cannot use your own referral code for booking.
      </div>
    );
  }

  if (!isValidReferralCode) {
    return (
      <div className="mb-4 p-2 bg-red-50 text-red-700 rounded-md text-sm">
        The referral code doesn't belong to any user.
      </div>
    );
  }

  return (
    <div className="mb-4 p-2 bg-green-50 text-green-700 rounded-md text-sm">
      Referral discount of £5 will be applied to your booking!
    </div>
  );
};

export default ReferralInfo;